import type { MenuItem } from '@/consts/navigation';
import { ROUTES } from '@/consts/routes';
import { useDynamicMenu } from '@/features/navigation/hooks/useDynamicMenu';
import { Navigate } from 'react-router';

const findRouteInMenu = (items: MenuItem[], route: string): boolean => {
  for (const item of items) {
    if (item.to === route) return true;
    if (item.children && findRouteInMenu(item.children, route)) return true;
  }
  return false;
};

export const HomeRedirect = () => {
  const { menu } = useDynamicMenu();

  if (findRouteInMenu(menu, ROUTES.chartering.estimatorNew)) {
    return <Navigate to={ROUTES.chartering.estimatorNew} replace />;
  }

  return null;
};
